import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'throttle-debounce';
import { DLModal, LoadingOverlay } from 'appSrc/components/Shards';
import { parseYouTubeUrl, convertYouTubeIdToImg } from 'appSrc/utils';
import { YOUTUBE_IMG_REGEX } from 'appSrc/utils/video';
import { PrimaryButton, Icon, DLTextField } from 'appSrc/components/UI';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import style from './styles/style.module.css';

const placeholder = 'https://via.placeholder.com/1120x630?text=X';

class VideoImageSelector extends Component {
    constructor( props ) {
        super( props );

        this.debounceLoad = debounce( 750, this.loadImage );

        this.state = {
            view: 'custom',
            imgSrc: placeholder,
            fetching: false,
            selection: '',
            customUrl: '',
            upload: '',
        };

        this.retrieving = false;
    }
    componentDidUpdate( prevProps ) {
        if( this.props.visible && !prevProps.visible ) {
            let { options } = this.props;
            let img = options.img;
            let newState = {
                view: 'custom',
                imgSrc: img || placeholder,
                fetching: false,
                selection: '',
                customUrl: '',
                upload: '',
                youtube: '',
            };

            if( YOUTUBE_IMG_REGEX.test( img ) ) {
                newState.selection = 'youtube';
                newState.youtube = img;
                newState.view = 'default';
            } else if( /^data:image\//i.test( img ) ) {
                newState.selection = 'upload';
                newState.upload = img;
                newState.view = 'custom';
            } else if( !!img ) {
                newState.selection = 'customUrl';
                newState.customUrl = img;
                newState.view = 'custom';
            }

            this.setState( newState );
        }
    }

    loadImage = ( src ) => {
        this.retrieving = true;
        this.setState( { imgSrc: src } );
    }
    imageLoaded = () => {
        if( this.retrieving ) {
            this.setState( { fetching: false } );
        }
    }
    imageError = () => {
        if( this.retrieving ) {
            this.setState( {
                imgSrc: placeholder,
                fetching: false,
            } );
        }
    }

    updateView = ( value ) => {
        this.setState( { view: value } );
    }
    updateViewWith = ( value ) => {
        return () => {
            this.updateView( value );
        };
    }

    updateSelection = ( value ) => {
        this.setState( {
            selection: value,
            imgSrc: this.state[ value ] || placeholder,
            fetching: true,
        } );
    }
    updateSelectionWith = ( value ) => {
        return () => {
            this.updateSelection( value );
        };
    }

    updateCustomUrl = ( evt, { value } ) => {
        this.retrieving = true;
        this.debounceLoad( value );

        this.setState( {
            customUrl: value,
            selection: 'customUrl',
            fetching: true,
        } );
    }

    cropFinish = ( image ) => {
        this.retrieving = true;

        this.setState( {
            imgSrc: image,
            upload: image,
            selection: 'upload',
            fetching: true,
        } );
    }

    updateYouTube = ( evt ) => {
        let image = evt.target.value;
        this.setState( {
            imgSrc: image,
            youtube: image,
            selection: 'youtube',
        } );
    }

    submitHandler = () => {
        this.props.onSubmit( this.state.imgSrc );
    }


    render() {
        const { view, selection, customUrl, youtube, imgSrc } = this.state;
        const { options } = this.props;

        const isValid = !this.state.fetching && !!imgSrc && imgSrc !== placeholder;

        return (
            <DLModal title={ this.props.title } visible={ this.props.visible }
            closeHandler={ this.props.closeHandler }
            className={ style.imageSelectModal }>
                <div className={ style.content }>
                    <div className={ style.tabs }>
                        <div className={ style.tab } data-active={ view === 'custom' }
                        onClick={ this.updateViewWith( 'custom' ) }>Custom</div>
                        { options.youtube &&
                            <div className={ style.tab } data-active={ view === 'default' }
                            onClick={ this.updateViewWith( 'default' ) }>Default</div>
                        }
                    </div>

                    <div className={ style.imageWrapper }>
                        <img src={ imgSrc } onLoad={ this.imageLoaded } onError={ this.imageError } />
                        <LoadingOverlay style={ this.state.fetching ? {} : { display: 'none' } } />
                    </div>


                    <div className={ style.contentWrapper } style={ { display: view === 'custom' ? 'block' : 'none' } }>
                        <div className={ style.radioPair }>
                            <div className={ style.radioWrapper }>
                                <input type='radio' name='selection' value='upload'
                                checked={ selection == 'upload' }
                                onChange={ this.updateSelectionWith( 'upload' ) }/>
                            </div>
                            <div className={ style.inputWrapper }>
                                <ImageCropModalWrapper
                                aspectRatio={ 16/9 }
                                wrapperStyle={ { display: 'block' } }
                                onFinish={ this.cropFinish }>
                                    <PrimaryButton
                                    value="image"
                                    fullWidth
                                    reverse
                                    label={ (
                                        <span style={ { display: 'flex', alignItems: 'center' } }>
                                            <Icon size={ 30 } icon='upload' />&nbsp;Upload Photo
                                        </span>
                                    ) }/>
                                </ImageCropModalWrapper>
                            </div>
                        </div>

                        <p className={ style.or }><span>or</span></p>

                        <div className={ style.radioPair }>
                            <div className={ style.radioWrapper }>
                                <input type='radio' name='selection' value='customUrl'
                                checked={ selection == 'customUrl' }
                                onChange={ this.updateSelectionWith( 'customUrl' ) }/>
                            </div>
                            <div className={ style.inputWrapper }>
                                <p className={ style.lable }>Image URL</p>
                                <DLTextField
                                placeholder='Insert Image URL'
                                value={ customUrl }
                                onChange={ this.updateCustomUrl }
                                fullWidth
                                noError />
                            </div>
                        </div>

                    </div>

                    { options.youtube &&
                        <div className={ `${ style.contentWrapper } ${ style.defaultPick }` } style={ { display: view === 'default' ? 'block' : 'none' } }>
                            <h3>Thumbnails from YouTube</h3>
                            <div className={ style.grid }>

                                <label className={ style.radioPair }
                                data-active={ selection == 'youtube' &&
                                    youtube == convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'jpg' ) }>
                                    <div className={ style.radioWrapper }>
                                        <input type='radio' name='youtube'
                                        value={ convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'jpg' ) }
                                        checked={ selection == 'youtube' &&
                                            youtube == convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'jpg' ) }
                                        onChange={ this.updateYouTube } />
                                    </div>
                                    <div className={ style.inputWrapper }>
                                        <p className={ style.lable }>Max Resolution</p>
                                        <img src={ convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'jpg' ) } />
                                    </div>
                                </label>


                                <label className={ style.radioPair }
                                data-active={ selection == 'youtube' &&
                                    youtube == convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'med/jpg' ) }>
                                    <div className={ style.radioWrapper }>
                                        <input type='radio' name='youtube'
                                        value={ convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'med/jpg' ) }
                                        checked={ selection == 'youtube' &&
                                            youtube == convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'med/jpg' ) }
                                        onChange={ this.updateYouTube } />
                                    </div>
                                    <div className={ style.inputWrapper }>
                                        <p className={ style.lable }>Medium Resolution</p>
                                        <img src={ convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'med/jpg' ) } />
                                    </div>
                                </label>


                                <label className={ style.radioPair }
                                data-active={ selection == 'youtube' &&
                                    youtube == convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'small/jpg' ) }>
                                    <div className={ style.radioWrapper }>
                                        <input type='radio' name='youtube'
                                        value={ convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'small/jpg' ) }
                                        checked={ selection == 'youtube' &&
                                            youtube == convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'small/jpg' ) }
                                        onChange={ this.updateYouTube } />
                                    </div>
                                    <div className={ style.inputWrapper }>
                                        <p className={ style.lable }>Standard Resolution</p>
                                        <img src={ convertYouTubeIdToImg( parseYouTubeUrl( options.youtube || '' ), 'small/jpg' ) } />
                                    </div>
                                </label>

                            </div>
                        </div>
                    }
                    <div className={ style.submitButton }>
                        <PrimaryButton
                        label="Select"
                        type="button"
                        onClick={ this.submitHandler }
                        fullWidth
                        disabled={ !isValid } />
                    </div>
                </div>
            </DLModal>
        );
    }
}
VideoImageSelector.propTypes = {
    title: PropTypes.string,
    visible: PropTypes.bool,
    closeHandler: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};
VideoImageSelector.defaultProps = {
    title: '',
    options: {},
    visible: false,
};

export default VideoImageSelector;
